module.exports = __webpack_public_path__ + "img/home3.4cb654e5.jpg";